var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { attrs: { cols: 12 } },
        [
          _c(
            "b-row",
            [
              this.editingVisit < 1
                ? _c(
                    "b-col",
                    {
                      staticClass: "scroll",
                      staticStyle: { "overflow-x": "auto" },
                      attrs: { cols: 12 }
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-col", { attrs: { cols: 12 } }, [
                            _c("h3", [_vm._v("Resultados")])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticStyle: { "max-height": "50rem" } }, [
                        _c("table", { staticClass: "table custom" }, [
                          _c("thead", { attrs: { id: "head" } }, [
                            _c("tr", [
                              _c(
                                "th",
                                { staticStyle: { "min-width": "75px" } },
                                [_vm._v("Acciones")]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                { staticStyle: { "min-width": "500px" } },
                                [_vm._v("Entidad")]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                { staticStyle: { "min-width": "200px" } },
                                [_vm._v("Fecha planificada")]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                { staticStyle: { "min-width": "200px" } },
                                [_vm._v("Fecha realizada")]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                { staticStyle: { "min-width": "250px" } },
                                [_vm._v("Gestor")]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                { staticStyle: { "min-width": "100px" } },
                                [_vm._v("Estado")]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                { staticStyle: { "min-width": "200px" } },
                                [_vm._v("Tipo actividad")]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                { staticStyle: { "min-width": "100px" } },
                                [_vm._v("Resultado")]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                { staticStyle: { "min-width": "250px" } },
                                [_vm._v("Observaciones")]
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            { attrs: { id: "body" } },
                            _vm._l(_vm.tableItems, function(item) {
                              return _c("tr", { key: item.id }, [
                                _c(
                                  "td",
                                  { staticStyle: { "min-width": "75px" } },
                                  [
                                    _c(
                                      "b-dropdown",
                                      {
                                        attrs: {
                                          variant: "link",
                                          "no-caret": ""
                                        }
                                      },
                                      [
                                        _c(
                                          "template",
                                          { slot: "button-content" },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-ellipsis-v",
                                              attrs: { "aria-hidden": "true" }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-dropdown-item-button",
                                          {
                                            on: {
                                              click: function($event) {
                                                _vm.editRow(
                                                  item.id_visita_entidad
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("Editar")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-dropdown-item-button",
                                          {
                                            on: {
                                              click: function($event) {
                                                _vm.removeRow(
                                                  item.id_visita_entidad
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("Eliminar")]
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "min-width": "500px" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        item.id_entidad_dict.nombre_entidad +
                                          " (CIF: " +
                                          item.id_entidad_dict.cif +
                                          ") - (SAP:" +
                                          item.id_entidad_dict.codigo_entidad +
                                          ")"
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "min-width": "200px" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatDate")(
                                          item.fecha_hora_proxima_visita,
                                          "DD/MM/YYYY HH:mm"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "min-width": "200px" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatDate")(
                                          item.fecha_hora_visita,
                                          "DD/MM/YYYY HH:mm"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "min-width": "250px" } },
                                  [
                                    _vm._v(
                                      _vm._s(item.nombre_visitador) +
                                        " (" +
                                        _vm._s(item.codigo_visitador) +
                                        ")"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "min-width": "100px" } },
                                  [_vm._v(_vm._s(item.status_visita))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "min-width": "200px" } },
                                  [_vm._v(_vm._s(item.tipo_actividad))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "min-width": "100px" } },
                                  [_vm._v(_vm._s(item.resultado))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticStyle: { "min-width": "250px" } },
                                  [_vm._v(_vm._s(item.observaciones))]
                                )
                              ])
                            })
                          )
                        ])
                      ])
                    ],
                    1
                  )
                : _c(
                    "b-col",
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-col", { attrs: { cols: 12 } }, [
                            _c("h3", [_vm._v("Resultados > Editando visita")])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: 12 } },
                            [
                              _c("ManageVisitsEntitiesResultsEdit", {
                                attrs: { "id-visita": this.editingVisit }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Layout/CommercialManagement/ManageVisitsEntitiesResults.vue?vue&type=template&id=25cd286a&scoped=true&
// module id = null
// module chunks = 